<div class="matches-card">

    <div class="flip-card-inner" *ngFor="let poll of pollData.mpoll">
        <div class="card-back">
            <div class="card uk-flex">
                <div class="brand-logo position-relative">
                    <a [routerLink]="['/'+appService.getCurrentCity()+'/deals/by/'+poll.merchant.slug]">
                        <div class="image">
                            <img src="{{poll.merchant.ipl_logo}}" class="w-100 fitimg">
                        </div>
                    </a>
                </div>
                <div class="info">
                    <p>{{poll.merchant_poll}}</p>
                    <div class="progress progress-agree">
                        <!-- <div [ngStyle]="{'width': poll.agree+'%'}" class="progress-bar">agree</div>
                        <div [ngStyle]="{'width': 100-poll.agree+'%'}" class="percentage">{{poll.agree}}%</div> -->
                        <div [ngStyle]="{'width': poll.agree+'%'}" class="progress-bar"></div>
                        <span class="review-text">Agree</span>
                        <span class="percentage">{{poll.agree}}%</span>
                    </div>
                    <!--progress end-->
                    <div class="progress mt-1 progress-disagree">
                        <!-- <div [ngStyle]="{'width': poll.disagree+'%'}" class="progress-bar">Disagree</div>
                        <div [ngStyle]="{'width': 100-poll.disagree+'%'}" class="percentage">{{poll.disagree}}%
                        </div> -->
                        <div [ngStyle]="{'width': poll.disagree+'%'}" class="progress-bar"></div>
                        <span class="review-text">Disagree</span>
                        <span class="percentage">{{poll.disagree}}%</span>
                    </div>
                    <!--progress end-->


                    <!--PROGRESS HTML EXAMPLE-->
                    <!-- <div class="progress progress-agree">
                        <div class="progress-bar" style="width:90%"></div>
                        <span class="review">Agree</span>
                        <span class="percentage">100%</span>
                    </div> -->

                </div>
            </div>

            <div class="card-footer greenbg" *ngIf="poll.status === 'Correct'">
                <p>HURRAY! {{poll.merchant.merchant_name}} PREDICTED RIGHT <span><i
          class="fa fa-check-circle-o"></i></span></p>
            </div>

            <div class="card-footer redbg" *ngIf="poll.status === 'Incorrect'">
                <p>OOPS! {{poll.merchant.merchant_name}} PREDICTION WAS WRONG <span><i
          class="fa fa-times-circle-o"></i></span></p>
            </div>

        </div>
        <!--card-back end-->
    </div>
</div>
<!--matches-card end-->

<div class="matches-card" hidden>
    <div class="flip-card-inner">
        <div class="card-back">
            <div class="card uk-flex">
                <div class="brand-logo position-relative">
                    <div class="image">
                        <img src="../assets/images/ipl/profile-user.png" class="w-100 fitimg">
                    </div>
                </div>
                <div class="info">
                    <p>Social has predicted that Mumbai will score than 160 plus? </p>
                    <div class="progress uk-flex progress-agree">
                        <div [ngStyle]="{'width': '70%'}" class="progress-bar">agree</div>
                        <div [ngStyle]="{'width': '30%'}" class="percentage">70%</div>
                    </div>
                    <!--progress end-->
                    <div class="progress uk-flex mt-1 progress-disagree">
                        <div [ngStyle]="{'width': '40%'}" class="progress-bar">Disagree</div>
                        <div [ngStyle]="{'width': '60%'}" class="percentage">40%</div>
                    </div>
                    <!--progress end-->
                </div>
            </div>
            <div class="card-footer greenbg">
                <p>HURRAY! SOCIAL PREDICTED RIGHT <span><i class="fa fa-check-circle-o"></i></span></p>
            </div>
        </div>
        <!--card-back end-->
    </div>
</div>
<!--matches-card end-->